import {TalentPoolProfileApplication, TalentPoolProfileResponse} from '../types/TalentPoolProfileTypes';

import {ApplicantRecruiting, MatchData} from '../../../../../types/shared-recruiting-types';

export function applicantFromTalentPoolProfileResponse(
  data: TalentPoolProfileResponse | undefined
): ApplicantRecruiting | undefined {
  const rawApplicant = data?.talentPoolProfile?.applicant;
  if (!rawApplicant) {
    return undefined;
  }

  const rawApplicantWithPicture = rawApplicant as {
    profilePictureUrl?: string;
    profile_picture_url?: string;
    profilePictureURL?: string;
    personalInformation?: {
      profilePictureUrl?: string;
      profile_picture_url?: string;
    };
  };

  const profilePictureUrl =
    rawApplicantWithPicture.profilePictureUrl?.trim() ||
    rawApplicantWithPicture.profile_picture_url?.trim() ||
    rawApplicantWithPicture.profilePictureURL?.trim() ||
    rawApplicantWithPicture.personalInformation?.profilePictureUrl?.trim() ||
    rawApplicantWithPicture.personalInformation?.profile_picture_url?.trim() ||
    undefined;

  return {
    resourceId: rawApplicant.resourceId,
    personalInformation: {
      resourceId: '',
      firstName: rawApplicant.personalInformation.firstName,
      lastName: rawApplicant.personalInformation.lastName,
      email: rawApplicant.personalInformation.email,
      mobilePhoneNumber: rawApplicant.personalInformation.mobilePhoneNumber,
    },
    keyFacts: {
      professionalExperience: {duration: 0, unit: 'years'},
      leadershipExperience: false,
      salary: {min: 0, max: 0},
      startDate: '',
      highestDegree: {en: '', de: ''},
    },
    resumeUrl:
      rawApplicant.resumeUrl?.trim() ||
      (rawApplicant as {resume_url?: string}).resume_url?.trim() ||
      undefined,
    profilePictureUrl,
    cultureType: rawApplicant.cultureType,
  };
}

export function applicationsFromTalentPoolProfileResponse(
  data: TalentPoolProfileResponse | undefined
): TalentPoolProfileApplication[] {
  const apps = data?.talentPoolProfile?.applications;
  return Array.isArray(apps) ? apps : [];
}

/** When the API omits `talent_pool_profile`, fall back to applicant-only stub. */
export function matchDataStubForTalentPoolContact(applicant: ApplicantRecruiting): MatchData {
  return {
    resourceId: '',
    updatedAt: '',
    createdAt: '',
    campaignName: '',
    status: '',
    tags: [],
    applicant,
  };
}
